// extracted by mini-css-extract-plugin
module.exports = {"upload":"ImageUploader_upload__2CDxE","wrapper":"ImageUploader_wrapper__2j9qV","inner":"ImageUploader_inner__2JKNH","text":"ImageUploader_text__1RXge"};